import { TuiBlockStatus, TuiCardLarge } from '@taiga-ui/layout';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ErrorPipe } from '@shared/pipes/error.pipe';
import { withRequestResult } from '@shared/request-state/rx-pipes/with-request-result.pipe';
import { mapToArray } from '@shared/rx-pipes/map-to-array.pipe';
import { map } from 'rxjs';
import { ExaminationsService } from '../../services/examinations.service';
import { ExaminationContentComponent } from '../examination-content/examination-content.component';
import { ExaminationsMobilePaneComponent } from '../examination-mobile-pane/examinations-mobile-pane.component';

@Component({
  selector: 'pxc-examinations-pane',
  imports: [
    CommonModule,
    TuiCardLarge,
    TuiBlockStatus,
    ErrorPipe,
    ExaminationContentComponent,
    ExaminationsMobilePaneComponent,
    TranslocoDirective,
  ],
  templateUrl: './examinations-pane.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block',
  },
})
export class ExaminationsPaneComponent {
  readonly isMobile = input(false);

  readonly examinationsService = inject(ExaminationsService);

  readonly examinationForms$ = this.examinationsService.examinationForms$.pipe(mapToArray(), withRequestResult());

  readonly shouldShowPane$ = this.examinationForms$.pipe(map((result) => result.isSuccess && result.data.length > 0));
}
